import { render, staticRenderFns } from "./DeletionMassiveModal.vue?vue&type=template&id=580e0d50&"
import script from "./DeletionMassiveModal.vue?vue&type=script&lang=js&"
export * from "./DeletionMassiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports